import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { WithEnterpriseId } from '@mews-commander/types';
import { DateTimeUtils, useTimezone } from '@mews/framework';

export const useQueryMulticurrencyConfiguration = ({ enterpriseId }: WithEnterpriseId) => {
    const timezone = useTimezone();

    const { data, isFetching } = useRepositorySuspenseQuery('multiCurrencyServiceConfiguration', 'get', {
        enterpriseId,
    });

    const multicurrencyStartDate = data?.startDateEligibilityMultiCurrency
        ? DateTimeUtils.dateTimeUtcStringToDate(data.startDateEligibilityMultiCurrency, timezone)
        : null;

    return {
        isMulticurrencyServiceEnabled: data.isMultiCurrencyServiceEnabled,
        isDccMulticurrencyServiceEnabled: data.isDccMultiCurrencyServiceEnabled,
        isFxMulticurrencyServiceEnabled: data.isFxMultiCurrencyServiceEnabled,
        isDccMulticurrencyServiceAvailable: data.isDccMultiCurrencyServiceAvailable,
        multicurrencyStartDate,
        isFetching,
    };
};
